import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { STRINGS, VARIANTS, BUTTON_COLORS} from "../../common/constants/commonConstants.js";
import { CUSTOMER_STRINGS} from "../../common/constants/customerModule/customerConstants.js";
import DialogComponent from "../../common/components/DialogComponent.jsx";

const EmailCustomerDialog = ({
    onEmail,
    open,
    selectedCustomer,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={selectedCustomer?.id ? CUSTOMER_STRINGS.EMAIL_CUSTOMER : CUSTOMER_STRINGS.ADD_CUSTOMER}
                actions={
                    <Button
                        onClick={onEmail}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SEND}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    An email message will be initiated immediately. The email body will be constructed based on the customer's last dataset and related campaign.
                    </Typography>
                </Box>
            </DialogComponent>
        </>
    )
};

export default EmailCustomerDialog;